import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { BUSINESS } from "@/data";

export const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14">
        <div>
          <p className="uppercase tracking-[0.2em] text-sm font-semibold text-brand">Get in touch</p>
          <h2 className="mt-3 font-display font-bold text-4xl md:text-5xl tracking-tight text-slate-900">
            We're right around the corner
          </h2>
          <p className="mt-4 text-lg text-slate-600 leading-relaxed">
            Have a question or ready to book? Call us or send your details and we'll take care of the rest.
          </p>

          <div className="mt-10 space-y-6">
            <a href={BUSINESS.phoneHref} data-testid="contact-phone" className="flex items-start gap-4 group">
              <span className="grid place-items-center h-12 w-12 rounded-xl bg-brand/10 text-brand shrink-0"><Phone strokeWidth={1.75} /></span>
              <div>
                <p className="text-sm text-slate-500">Call or text</p>
                <p className="font-display font-semibold text-xl text-slate-900 group-hover:text-brand transition-colors">{BUSINESS.phone}</p>
              </div>
            </a>
            <a href={BUSINESS.emailHref} data-testid="contact-email" className="flex items-start gap-4 group">
              <span className="grid place-items-center h-12 w-12 rounded-xl bg-brand/10 text-brand shrink-0"><Mail strokeWidth={1.75} /></span>
              <div>
                <p className="text-sm text-slate-500">Email</p>
                <p className="font-display font-semibold text-xl text-slate-900 group-hover:text-brand transition-colors">{BUSINESS.email}</p>
              </div>
            </a>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-5 content-start">
          <div className="rounded-2xl border border-slate-200 p-7 bg-[#F8FAFC]">
            <MapPin className="text-brand" strokeWidth={1.5} />
            <h3 className="mt-4 font-display font-semibold text-lg text-slate-900">Service Area</h3>
            <ul className="mt-3 space-y-1.5 text-slate-600">
              {BUSINESS.areas.map((a) => <li key={a}>{a}</li>)}
            </ul>
          </div>
          <div className="rounded-2xl border border-slate-200 p-7 bg-[#F8FAFC]">
            <Clock className="text-brand" strokeWidth={1.5} />
            <h3 className="mt-4 font-display font-semibold text-lg text-slate-900">Hours</h3>
            <ul className="mt-3 space-y-2 text-slate-600 text-sm">
              {BUSINESS.hours.map((h) => (
                <li key={h.day}>
                  <span className="block font-medium text-slate-900">{h.day}</span>
                  {h.time}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
